import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { MonthCalendar } from "@mui/x-date-pickers/MonthCalendar";
import { getYear, startOfMonth } from "date-fns";
import { useState } from "react";
import { FlatRowDatePanelYearHeader } from "web_myplann/Shared/Components/FlatRow/FlatRowDatePanelYearHeader";
import { isYearStepEnabled } from "web_myplann/Shared/Components/FlatRow/isYearStepEnabled";
import { resolveInitialPanelDate } from "web_myplann/Shared/Components/FlatRow/resolveInitialPanelDate";
import { useDateFnsLocale } from "web_myplann/Shared/Hooks/useDateFnsLocale";

type Props = {
	value: Date | null;
	minDate?: Date;
	maxDate?: Date;
	onSelect: (date: Date) => void;
};

export const FlatRowDateMonthPanel = ({
	value,
	minDate,
	maxDate,
	onSelect,
}: Props) => {
	const locale = useDateFnsLocale();
	const [panelYear, setPanelYear] = useState(() =>
		getYear(resolveInitialPanelDate(value, minDate, maxDate)),
	);

	return (
		<LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={locale}>
			<FlatRowDatePanelYearHeader
				year={panelYear}
				previousEnabled={isYearStepEnabled(panelYear, -1, minDate, maxDate)}
				nextEnabled={isYearStepEnabled(panelYear, 1, minDate, maxDate)}
				onYearChange={setPanelYear}
			/>
			<MonthCalendar
				value={value}
				referenceDate={new Date(panelYear, 0, 1)}
				currentMonth={new Date(panelYear, 0, 1)}
				minDate={minDate}
				maxDate={maxDate}
				monthsPerRow={3}
				disableHighlightToday
				onChange={(month) => onSelect(startOfMonth(month))}
			/>
		</LocalizationProvider>
	);
};
